import styled, { keyframes } from "styled-components";

const cardEnter = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Row = styled.div<{ $index?: number }>`
  display: flex;
  gap: 14px;
  padding: 15px 0;
  cursor: pointer;
  align-items: flex-start;
  font-family: ${(p) => p.theme.tokens.font.family};
  animation: ${cardEnter} 0.34s ease both;
  animation-delay: ${(p) => Math.min(p.$index ?? 0, 8) * 40}ms;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  & + & {
    border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
  }
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
  padding-top: 1px;
`;

export const Title = styled.div`
  font-weight: 800;
  font-size: 15.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
  letter-spacing: -0.2px;
`;

export const Description = styled.div`
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.muted};
  line-height: 1.4;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PriceRow = styled.div`
  margin-top: 9px;
  display: flex;
  align-items: baseline;
  gap: 6px;
`;

export const Price = styled.span`
  font-weight: 900;
  font-size: 15.5px;
  color: ${(p) => p.theme.tokens.colors.teal};
`;

export const OldPrice = styled.span`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  text-decoration: line-through;
`;

export const ThumbWrap = styled.div`
  position: relative;
  width: 88px;
  height: 88px;
  flex-shrink: 0;
  margin-right: 6px;
`;

export const AddFab = styled.button<{ $active: boolean }>`
  position: absolute;
  right: -6px;
  bottom: -6px;
  width: 34px;
  height: 34px;
  border-radius: ${(p) => p.theme.tokens.radii.sm}px;
  border: none;
  background: ${(p) => (p.$active ? p.theme.tokens.gradients.accent : p.theme.tokens.colors.surface)};
  color: ${(p) => (p.$active ? p.theme.tokens.colors.surface : p.theme.tokens.colors.teal)};
  box-shadow: 0 5px 14px rgba(16, 32, 27, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 900;
  font-size: 15.5px;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.12s ease;

  &:active {
    transform: scale(0.88);
  }
`;
